import {
  MedicalAttestationResendingInput,
  MedicalAttestationSending,
  MedicalAttestationSendingInput
} from '../../lib/types/models/medical-attestation-sending/medical-attestation-sending'
import { IdInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function sendMedicalStatement({ id, ...data }: IdInput<MedicalAttestationSendingInput>) {
  return restApiClient
    .url(constructApiUrl(API.enrollments.sendMedicalAttestation.url, { id }))
    .post<MedicalAttestationSending, MedicalAttestationSendingInput>(data)
}

export function resendMedicalStatement({
  id,
  ...data
}: IdInput<MedicalAttestationResendingInput>) {
  return restApiClient
    .url(constructApiUrl(API.enrollments.resendMedicalAttestation.url, { id }))
    .post<MedicalAttestationSending, MedicalAttestationResendingInput>(data)
}
